import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { ReplaySubject, BehaviorSubject } from 'rxjs';
import { ListingParams } from '../_models/common/listingParams';
@Injectable({
  providedIn: 'root'
})
export class DataViewService {
  private gridReload = new Subject();
  constructor() {

  }
  setgridReloadParam(title: ListingParams) {
    this.gridReload.next(title);
  }
  getgridReloadParam(): Observable<any> {
    return this.gridReload.asObservable();
  }
}
